import { render } from "./HeaderContent.vue?vue&type=template&id=6e4851c8"
import script from "./HeaderContent.vue?vue&type=script&lang=js"
export * from "./HeaderContent.vue?vue&type=script&lang=js"

import "./HeaderContent.vue?vue&type=style&index=0&id=6e4851c8&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/navigation/HeaderContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e4851c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e4851c8', __exports__)) {
    console.log('reload')
    api.reload('6e4851c8', __exports__)
  }
  
  module.hot.accept("./HeaderContent.vue?vue&type=template&id=6e4851c8", () => {
    console.log('re-render')
    api.rerender('6e4851c8', render)
  })

}


export default __exports__